import { Button, Typography } from "@mui/material";
import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "./NameCell.scss";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

export default function NameCell({ params, onClick, getRedirectUrl, showIcon = false, disabled }) {
  const { value, row } = params;
  const navigate = useNavigate();

  const navigateToDetail = () => {
    if (getRedirectUrl) {
      const redirectLink = getRedirectUrl(params);
      return navigate(redirectLink);
    }
    if (row.nameLink) navigate(row.nameLink);
  };

  const handleClick = () => {
    if (onClick) onClick(params);
    else navigateToDetail();
  };

  return (
    <>
      {disabled ?
        <Typography variant="body2">{value}</Typography> :
        <Button data-test-id={`project-list-names-${value}`} className="proGrid-name" variant="text" color="primary" disabled={disabled} onClick={handleClick} startIcon={showIcon ? <AccountCircleIcon /> : null}>
          {value}
        </Button>
      }
    </>
  );
}

NameCell.propTypes = {
  params: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  getRedirectUrl: PropTypes.func.isRequired,
  showIcon: PropTypes.bool,
};
